import { useState } from 'react'
import { useAuth } from './AuthContext'
import { LoginPage } from './LoginPage'
import { api, ApiError } from '../../shared/api/http'
import './tvApproval.css'

export function TvApprovalPage() {
  const { user } = useAuth()
  const [code] = useState(() => window.location.hash.slice(1).toUpperCase())
  const [done, setDone] = useState(false)
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')
  if (!/^[A-F0-9]{12}$/.test(code)) return <div className="tv-approval"><section><h1>Entrar na TV</h1><p>Abra um novo QR Code na TV e escaneie com a câmera do celular.</p></section></div>
  if (!user) return <LoginPage onSignedIn={() => {}} />
  async function approve() {
    setBusy(true); setError('')
    try {
      await api('/auth/tv/approve', { method: 'POST', body: JSON.stringify({ userCode: code }) })
      setDone(true); window.history.replaceState(null, '', '/tv')
    } catch (cause) {
      setError(cause instanceof ApiError && cause.code === 'pairing_expired'
        ? 'Este código expirou ou já foi usado. Gere outro na TV.' : 'Não foi possível confirmar. Tente novamente.')
    } finally { setBusy(false) }
  }
  return <div className="tv-approval"><section>
    <img src="/logo.png" alt="Spectra Guard AI" />
    <h1>{done ? 'TV autorizada' : 'Conectar sua TV'}</h1>
    {done ? <p>Volte à TV. Sua conta será conectada automaticamente.</p> : <>
      <p>Confira se este código é o mesmo que aparece na sua TV:</p>
      <strong className="tv-code">{code.match(/.{4}/g)?.join(' ')}</strong>
      <p>Você está autorizando o Spectra Guard AI da TV a entrar como <strong>{user.fullName}</strong>.</p>
      <button disabled={busy} onClick={() => void approve()}>{busy ? 'Confirmando…' : 'Confirmar acesso na minha TV'}</button>
      <p>Só confirme se você abriu este QR Code na sua própria TV.</p>
    </>}
    {error && <p role="alert">{error}</p>}
  </section></div>
}
